// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper_wrapper__PhIpa","infoMessage":"wrapper_infoMessage__u55C8","errorMessage":"wrapper_errorMessage__Uuyc9","tenantPage":"wrapper_tenantPage__NVzyn"};